import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import CodeInputField from "@ticketingplatform/ui/dist/components/atoms/Fields/CodeInput/CodeInputField";
import { Flex } from "components/styles";
import { FormattedMessage } from "react-intl";
import { LoginFormValues, UseLoginForm } from "views/Login/types";
import { useForm, useFormState } from "react-final-form";
import useTimer from "hooks/useTimer";

const LoginStep2: React.FC<ReturnType<UseLoginForm>> = ({
  loading,
  resendCode,
  secondsUntilNextloginAttempt,
}) => {
  const { mutators } = useForm<LoginFormValues>();
  const { values } = useFormState<LoginFormValues>();
  const { time: remainingTime, resetTimer } = useTimer(
    secondsUntilNextloginAttempt
  );

  return (
    <Flex gap=".75rem" flexDirection="column" py=".75rem">
      <Text
        variant="typo5"
        color="blueDianne"
        textAlign="center"
        fontWeight="semiBold"
      >
        <FormattedMessage defaultMessage="We sent you a code to verify your phone number" />
      </Text>
      <CodeInputField
        type="number"
        fields={6}
        inputMode="numeric"
        name="pinCode"
        pattern="/[0-9]/"
        variant="secondary"
        disabled={loading}
      />
      {remainingTime > 0 && (
        <Text
          variant="typo5"
          color="blueDianne"
          textAlign="center"
          fontWeight="semiBold"
        >
          <FormattedMessage
            defaultMessage="After {remainingTime} second you can resend OTP."
            values={{
              remainingTime,
            }}
          />
        </Text>
      )}
      <Button
        type="submit"
        $mode="tertiary"
        disabled={loading || !values.pinCode || values.pinCode.length < 6}
      >
        <FormattedMessage defaultMessage="Next" />
      </Button>
      <Text
        variant="typo5"
        color="blueDianne"
        textAlign="center"
        fontWeight="semiBold"
      >
        <FormattedMessage defaultMessage="I didn’t receive a code. " />{" "}
        <Button
          type="button"
          $mode="link"
          disabled={loading}
          onClick={async () => {
            await resendCode(values.phoneNumber);
            mutators.setValue("pinCode", "");
            resetTimer();
          }}
        >
          <Text variant="typo5" fontWeight="black" as="strong">
            <FormattedMessage defaultMessage="Resend OTP." />
          </Text>
        </Button>
      </Text>
    </Flex>
  );
};

export default LoginStep2;
